export const billingToDeliveryDate = (billingDate, offsetDays) => {
	const deliveryDate = new Date(billingDate);
	deliveryDate.setDate(deliveryDate.getDate() + offsetDays);
	return `${deliveryDate.toDateString()} ${deliveryDate.toTimeString()}`;
};

export const calculateNextBillingDate = ({ intervalType, intervalCount }) => {
	const today = new Date();
	switch (intervalType) {
		case "DAY":
		case "CUSTOM":
			return today.setDate(today.getDate() + intervalCount);
		case "WEEK":
			return today.setDate(today.getDate() + intervalCount * 7);
		case "MONTH":
			return today.setMonth(today.getMonth() + intervalCount);
		case "YEAR":
			return today.setFullYear(today.getFullYear() + intervalCount);
	}
};

export const isSameDate = (date1, date2) => {
	const d1 = date1 instanceof Date ? date1 : new Date(date1);
	const d2 = date2 instanceof Date ? date2 : new Date(date2);

	return d1.getFullYear() === d2.getFullYear() &&
		d1.getMonth() === d2.getMonth() &&
		d1.getDate() === d2.getDate();
};

export const isDateAvailable = (date, disabledDatesAndWeekdays, latestOrderDate) => {
	const disabledDates = disabledDatesAndWeekdays.filter(item => Array.isArray(item));
	const disabledDays = disabledDatesAndWeekdays.filter(item => !Array.isArray(item));
	const latestOrderDateObj = new Date(latestOrderDate);

	if (
		disabledDates.some(([year, month, day]) => isSameDate(date, new Date(year, month, day))) ||
		isSameDate(date, latestOrderDateObj) ||
		disabledDays.includes(date.getDay() + 1)
	)
		return false;

	return true;
};


export const getCalendarDaysDiff = (date1, date2) => {
	const d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
	const d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

	const diffTime = d2.getTime() - d1.getTime();
	return Math.floor(diffTime / (1000 * 60 * 60 * 24));
};